var map = {
	"./BardClass.jpg": 8281,
	"./CampaignRules1.jpg": 8132,
	"./CampaignRules2.jpg": 4054,
	"./ClassRequirements.jpg": 1970,
	"./ClassXPTables.jpg": 6119,
	"./CombatActions.jpg": 7346,
	"./CombatCheatSheet.jpg": 2272,
	"./CriticalHits.jpg": 4118,
	"./FumbleTable.jpg": 570,
	"./Potions00.jpg": 9768,
	"./SavingThrows.jpg": 1833,
	"./ScrollFailure.jpg": 7430,
	"./SpellsByLevel.jpg": 9217,
	"./ThiefSkills.jpg": 5939,
	"./ToHit.jpg": 2677,
	"./ToHitAndCrit.jpg": 3426,
	"./TurnUndead.jpg": 8625,
	"./items/Armor.jpg": 9533,
	"./items/Bows.jpg": 3790,
	"./items/Potions.jpg": 8004,
	"./items/Weapons.jpg": 5603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6390;